import { Footer } from "layout/components/footer/footer"
import { Contact } from "pages/home/containers/contact/contact"
import { HARDCODED_RATING, HARDCODED_RATINGS_TOTAL } from "pages/home/home"
import { useEffect } from "react"
import { Help } from "./containers/help"
import { FenetresMain } from "./containers/main"
import { PrixTable } from "./containers/table"

export const Fenetres = () => {

    useEffect(() => {
        document.title = 'Fenétres avec volet roulant'
    }, [])

    return (
        <>
            <FenetresMain />
            <Help />
            <PrixTable />
            <Contact />
            <Footer rating={HARDCODED_RATING} user_ratings_total={HARDCODED_RATINGS_TOTAL} />
        </>
    )
}